module.exports = __webpack_public_path__ + "static/media/20210109_220807_936_IMG_1828.7363a604.jpg";